import { type FC } from 'react';

import { withFlags } from '@confluence/flags/entry-points/withFlags';
import { type FlagsStateContainer } from '@confluence/flags/entry-points/FlagsStateContainer';

import { useRealtimeAccessRequestsFlags } from './useRealtimeAccessRequestsFlags';

interface RealtimeAccessRequestsProps {
	contentType: string;
	contentId: string;
	pageTitle: string | null | undefined;
	flags: FlagsStateContainer;
	onReviewRequestsClick: () => void;
}

const RealtimeAccessRequestsInternal: FC<RealtimeAccessRequestsProps> = ({
	contentType,
	contentId,
	pageTitle,
	flags,
	onReviewRequestsClick: onReviewRequests,
}) => {
	useRealtimeAccessRequestsFlags({
		onReviewRequests,
		contentId,
		contentType,
		pageTitle,
		flags,
	});

	return null;
};

export const RealtimeAccessRequests = withFlags(RealtimeAccessRequestsInternal);
